import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Home } from 'lucide-react';

const AccountDeleted = () => {
  const navigate = useNavigate();

  // Auto redirect after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen gradient-secondary flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Account Eliminato</h1>
          <p className="text-muted-foreground">
            Il tuo account è stato eliminato definitivamente
          </p>
        </div>

        <Card className="glass border-white/20">
          <CardHeader className="text-center pb-4">
            <CardTitle className="text-white">Eliminazione Completata</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mx-auto">
                <CheckCircle className="w-6 h-6 text-green-400" />
              </div>
              
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-white">
                  Account eliminato con successo
                </h3>
                <div className="text-sm text-muted-foreground space-y-1">
                  <p>• Il tuo profilo è stato rimosso definitivamente</p>
                  <p>• Tutti i tuoi post e dati sono stati cancellati</p>
                  <p>• Le conversazioni sono state rimosse</p>
                  <p>• Non potrai più accedere con queste credenziali</p>
                </div>
              </div>
            </div>

            <div className="pt-4 border-t border-white/10">
              <p className="text-sm text-muted-foreground mb-4">
                Grazie per aver fatto parte della nostra comunità.
                Sarai reindirizzato alla home page tra pochi secondi.
              </p>
              
              <Button 
                onClick={() => navigate('/')}
                className="w-full"
              >
                <Home className="w-4 h-4 mr-2" />
                Vai alla Home Page
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            Se cambi idea, puoi sempre creare un nuovo account con un'altra email
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountDeleted;